export default __webpack_public_path__ + "static/media/Matrix.96f91b2f.svg";